import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from './useApi'
import { IFlagRunRequest } from '../gen/api'

const getTenant = () => localStorage.getItem('tenant_id') ?? ''

export const useAvailableFlags = () =>
  useQuery(['flagAdmin', 'flags'], async () => await apiClient.listFlags(getTenant()).then((res) => res.data))

export const useRunFlags = () => {
  const queryClient = useQueryClient()
  return useMutation(
    ['flagAdmin', 'run'],
    async (request: IFlagRunRequest) => await apiClient.runFlags(getTenant(), request).then((res) => res.data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['flagAdmin', 'history'])
      },
    }
  )
}

export const useRunStatus = (runId: number | null) =>
  useQuery(
    ['flagAdmin', 'status', runId],
    async () => {
      if (runId === null) return null
      return await apiClient.getRunStatusEndpoint(getTenant(), runId).then((res) => res.data)
    },
    {
      enabled: runId !== null,
      refetchInterval: (data) => {
        if (!data) return 2000
        const d = data as any
        if (d.status === 'running') return 2000
        return false
      },
    }
  )

export const useFlagRunHistory = () =>
  useQuery(['flagAdmin', 'history'], async () => await apiClient.getHistory(getTenant()).then((res) => res.data))

export const useRollbackRun = () => {
  const queryClient = useQueryClient()
  return useMutation(
    ['flagAdmin', 'rollback'],
    async (runId: number) => await apiClient.rollback(getTenant(), runId).then((res) => res.data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['flagAdmin', 'history'])
      },
    }
  )
}
